module.exports = {
  common: {
   text1:"Enter your phone number",
   text2:"Enter your email account",
   text3:"Please enter the verification code",
   text4:"Enter the invitation code",
   text5:"Enter your password",
   text6:"Please enter your password again",
   text7:"Register now",
   text8:"Use your phone number",
   text9:"Use your email",
   text10:"Download APK",
   text11:"Copy the link",
   text12:"Get code",
   text13:"Please enter a password that combines numbers, uppercase and lowercase letters, and is at least 8 characters long",
   text14:"The two passwords you entered do not match, please re-enter",
   text15:"Registration successful",
   text16:"Please check the page parameters",
   text17:"Verification code sent successfully!",
   text18:"Please enter correctly",
   text19:"Phone number",
   text20:"Email address",
   text21:"Text has been copied to the clipboard",
  },
};
